import homeHeroDefault from './homepage-hero/default.js';
import homeHeroSpring2024 from './homepage-hero/2024-spring.js';
import homeHeroSummer2025 from './homepage-hero/2025-summer.js';

export default () => {
  if (document.querySelector('[data-hero-campaign="default"]'))
    homeHeroDefault();
  if (document.querySelector('[data-hero-campaign="2024-spring"]'))
    homeHeroSpring2024();
  if (document.querySelector('[data-hero-campaign="2025-summer"]'))
    homeHeroSummer2025();
};
